import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetOrganizationV1OrganizationsOrgIdGetData,
  type GetOrganizationV1OrganizationsOrgIdGetError,
  type GetOrganizationV1OrganizationsOrgIdGetResponse,
  getOrganizationV1OrganizationsOrgIdGet,
} from '../../generated';

export type GetOrganizationQueryVariables = GetOrganizationV1OrganizationsOrgIdGetData['path'];

export type GetOrganizationQuery = GetOrganizationV1OrganizationsOrgIdGetResponse;

export const useGetOrganizationQuery = <
  TData = GetOrganizationQuery,
  TError = GetOrganizationV1OrganizationsOrgIdGetError,
>(
  { org_id }: GetOrganizationQueryVariables,
  options?: Omit<UseQueryOptions<GetOrganizationQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetOrganizationQuery, TError, TData>({
    queryKey: ['GetOrganization', { org_id }],
    queryFn: async () => {
      const { data } = await getOrganizationV1OrganizationsOrgIdGet({
        path: { org_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetOrganizationQuery.getKey = ({ org_id }: GetOrganizationQueryVariables) => ['GetOrganization', { org_id }];

useGetOrganizationQuery.fetcher = ({ org_id }: GetOrganizationQueryVariables, _headers?: RequestInit['headers']) => {
  return async () => {
    const { data } = await getOrganizationV1OrganizationsOrgIdGet({
      path: { org_id },
      throwOnError: true,
    });
    return data;
  };
};
